export default __webpack_public_path__ + "static/media/increase-serving.94e7b381.svg";